import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';
import { categorySlugMap } from '@/mocks/categories';

interface VideoCardProps {
  video: Video;
  size?: 'normal' | 'large';
}

export default function VideoCard({ video, size = 'normal' }: VideoCardProps) {
  return (
    <Link
      to={`/video/${video.id}`}
      className="group block"
    >
      <div className={`relative overflow-hidden rounded-lg mb-3 ${
        size === 'large' ? 'aspect-[16/9]' : 'aspect-[16/9]'
      }`}>
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 久久在线观看高清视频`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <span className="absolute bottom-2 right-2 bg-black/75 text-white text-xs px-2 py-0.5 rounded whitespace-nowrap">
          {video.duration}
        </span>
        {video.isNew && (
          <span className="absolute top-2 left-2 bg-accent-500 text-white text-xs px-2 py-0.5 rounded whitespace-nowrap">
            最新
          </span>
        )}
        {video.isHot && !video.isNew && (
          <span className="absolute top-2 left-2 bg-primary-500 text-white text-xs px-2 py-0.5 rounded whitespace-nowrap">
            热门
          </span>
        )}
        <div className="absolute top-2 right-2 w-8 h-8 flex items-center justify-center rounded-full bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <i className="ri-play-fill text-white text-base"></i>
        </div>
      </div>

      <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug mb-1.5">
        {video.title}
      </h3>

      <div className="flex items-center gap-3 text-xs text-foreground-500">
        <span className="flex items-center gap-1">
          <div className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
          </div>
          {video.rating}
        </span>
        <span>{categorySlugMap[video.category] || video.category}</span>
        <span>{video.year}</span>
      </div>
    </Link>
  );
}